import { StyleSheet, View } from 'react-native';
import { AlertTriangle, Target } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type LossReasonCardProps = {
  reasons: string[];
  weakPoints: string[];
};

export function LossReasonCard({ reasons, weakPoints }: LossReasonCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <AlertTriangle size={18} color={tokens.colors.danger} />
        <AppText variant="body" weight="bold">
          失分归因
        </AppText>
      </View>
      {reasons.map((reason) => (
        <AppText key={reason} variant="caption" tone="muted">
          · {reason}
        </AppText>
      ))}
      <View style={styles.weakSection}>
        <View style={styles.header}>
          <Target size={16} color={tokens.colors.warning} />
          <AppText variant="caption" tone="warning" weight="bold">
            薄弱知识点
          </AppText>
        </View>
        {weakPoints.map((point) => (
          <View key={point} style={styles.pointPill}>
            <AppText variant="caption" tone="primary" weight="bold">
              {point}
            </AppText>
          </View>
        ))}
      </View>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  weakSection: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.md,
    backgroundColor: tokens.colors.background,
  },
  pointPill: {
    borderRadius: tokens.radius.full,
    paddingHorizontal: tokens.spacing.sm,
    paddingVertical: tokens.spacing.xs,
    backgroundColor: tokens.colors.surfaceMuted,
  },
});
